import type { ComponentChildren } from "preact";
import { cx } from "./lib/cx.ts";
import { Icon } from "./Icon.tsx";

/**
 * A whole row you choose to start something: the question you would send, what
 * it covers under it, an optional figure on the right and an arrow. Put rows
 * inside a `List`. Rule: the row is one button, so the whole width is the
 * target; `hint` is a quiet extra line (such as an example) and `active` marks
 * the row a walkthrough is pointing at. Not for navigation: use a ListRow with
 * a link.
 */
export function ChoiceRow({ title, sub, meta, hint, active, arrow = true, onSelect, class: className }: {
  title: ComponentChildren;
  sub?: ComponentChildren;
  /** A short figure beside the arrow, such as a bid. */
  meta?: ComponentChildren;
  hint?: ComponentChildren;
  active?: boolean;
  arrow?: boolean;
  onSelect?: () => void;
  class?: string;
}) {
  return (
    <button type="button" class={cx("ui-choice", className)} data-active={active ? "" : undefined} onClick={onSelect}>
      <span class="ui-choice__text"><strong>{title}</strong>{sub && <span>{sub}</span>}{hint && <span class="ui-choice__hint">{hint}</span>}</span>
      {meta && <span class="ui-choice__meta">{meta}</span>}
      {arrow && <Icon name="arrow" size={16} class="ui-choice__go" />}
    </button>
  );
}
